import * as idb from "idb/with-async-ittr"

var db = null;
export async function loadDB() {
    db = await idb.openDB("mydb", 10, {
            upgrade(db, oldV, newV, transaction) {
                    if(oldV < 4) {
                        db.createObjectStore("Inspections", {"keyPath":"id"});
                    }
					if(oldV < 6) {
						db.createObjectStore("Users"); // Single instance so no key
					}
					if(oldV < 7) {
						db.createObjectStore("Surveys", {"keyPath":"id"});
					}
					if(oldV < 8) {
						db.createObjectStore("Jobs", {"keyPath":"id"});
					}
					if(oldV < 9) {
						db.createObjectStore("ComponentTypes", {"keyPath":"id"});
					}
					if(oldV < 10) {
						let inspStore = transaction.objectStore("Inspections");
						inspStore.createIndex("jobIdIndex", "jobId", {unique: false});
					}
            },
            blocked() {
            },
            blocking() {
            },
            terminated() {
            },
    });

    return db;
}
export async function getDB() {
    if(db == null) {
        db = loadDB();
    }
    return db;
}

